import { Component, Input, OnInit } from '@angular/core';
import { ChangeDateEvent, GungCalendarItem } from 'gung-common';
import { first, map } from 'rxjs';
import {
  ActivityInternal,
  ActivityInternalService
} from '../../../services/activity-internal/activity-internal.service';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { MetadataService } from '../../../services/metadata/metadata.service';
import { ActivityInternalCalendarItemMapperService } from '../../../services/activity-internal-calendar-item-mapper/activity-internal-calendar-item-mapper.service';

@Component({
    selector: 'lib-activity-internal-gung-calendar',
    templateUrl: './activity-internal-gung-calendar.component.html',
    styleUrls: ['./activity-internal-gung-calendar.component.css'],
    standalone: false
})
export class ActivityInternalGungCalendarComponent implements OnInit {
  calendarItemsList: GungCalendarItem[] = [];

  @Input() weekView = false;

  constructor(
    protected activityInternalService: ActivityInternalService,
    protected gungModalService: GungModalService,
    protected metadataService: MetadataService,
    protected calendarItemMapperService: ActivityInternalCalendarItemMapperService
  ) {}

  ngOnInit(): void {
    this.activityInternalService
      .getAll()
      .pipe(
        map(result =>
          result.sort((a, b) => {
            if (new Date(a.activityDate) > new Date(b.activityDate)) {
              return 1;
            }
            if (new Date(a.activityDate) < new Date(b.activityDate)) {
              return -1;
            }
            return 0;
          })
        )
      )
      .subscribe(res => {
        this.calendarItemsList = this.calendarItemMapperService.mapToCalendarItems(res);
      });
  }

  createActivity(selectedDate: Date) {
    this.gungModalService.openCreateActivityModal(undefined, undefined, undefined, undefined, selectedDate).then(
      result => {},
      reject => {}
    );
  }

  changeActivityDate(event: ChangeDateEvent) {
    this.activityInternalService
      .getById(event.id)
      .pipe(first())
      .subscribe(activity => {
        activity.activityDate = event.date.toISOString();
        this.activityInternalService
          .postActivityInternal(activity)
          .pipe(first())
          .subscribe(_ => {});
      });
  }
}
